/**
 * @graph-stack product-innovation-lab
 * @graph-domain Engineering
 * @graph-business QA責任評価レイアウト。QA責任評価関連ページのOutletラッパー
 * @graph-connects none
 */
import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '../components/auth/index.js';

/** @graph-connects none */
export const Route = createFileRoute('/qa-responsibility')({
  component: QaResponsibilityLayout,
});

/**
 * @graph-connects ProtectedRoute [calls] VIEW_QA_RESPONSIBILITY 権限でアクセスをガードする
 */
function QaResponsibilityLayout() {
  return (
    <ProtectedRoute pageKey="qaResponsibility">
      <Outlet />
    </ProtectedRoute>
  );
}
